export const getInitialContractorToken = () => {
  if (typeof window === "undefined") {
    return "";
  }
  const params = new URLSearchParams(window.location.search);
  return params.get("Kontrahent_IdHTTP") || "";
};

export const getInitialResetToken = () => {
  if (typeof window === "undefined") {
    return "";
  }
  const params = new URLSearchParams(window.location.search);
  return params.get("token") || params.get("resetToken") || "";
};


